module.exports = __webpack_public_path__ + "static/media/tempesta.a5844bb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/tempesta.svg
// module id = 821
// module chunks = 0